import pluginForms from 'grapesjs-plugin-forms';
import customCodePlugin from 'grapesjs-custom-code';
import pluginTooltip from 'grapesjs-tooltip';
import grapesjsTabsPlugin from 'grapesjs-tabs';
import grapesjs from 'grapesjs';
import LoadStyles from './LoadStyles';
import LoadPanels from './LoadPanels';
import LoadComponents from './LoadComponents';
import LoadAssetTypes from './LoadAssetTypes';
import LoadCommands from './LoadCommands/LoadCommands';
import LoadClasses from './LoadClasses';
import 'grapesjs/dist/css/grapes.min.css';
import 'grapesjs-blocks-basic';
import LoadProperties from './LoadProperties/LoadProperties';

const initGrapes = (setEditor,setTriggeredButtonFlow, setIndexPageFlow,setLoadSpinnerCreateJavascript, setAnchorApplyStylingEl) => {

    const myNewComponentTypes = (editor) => {
        LoadComponents(editor, setTriggeredButtonFlow, setIndexPageFlow);
      };
    
    const myNewCommands = (editor) => {
        LoadCommands(editor, setLoadSpinnerCreateJavascript, setAnchorApplyStylingEl);
    };

    const myNewAssetTypes = (editor) => {
        LoadAssetTypes(editor);
    };

    const myNewClasses = (editor) => {
      LoadClasses(editor);
    }

    const myNewProperties = (editor) => {
      LoadProperties(editor);
    }
    
    setEditor(
        grapesjs.init({
          // Indicate where to init the editor. You can also pass an HTMLElement
          fromElement: true,
          noticeOnUnload: false,
          container: '#gjs',
          jsInHtml: false,
          allowScripts: 1,
          protectedCss: '',
          cssComposer: { important: true },
          baseCss: `
          * {
            box-sizing: border-box;
          }
          html, body, [data-gjs-type=wrapper] {
            min-height: 100%;
          }
          body {
            margin: 0;
            height: 100%;
            overflow: auto;
            overflow-x: auto;
          }
          [data-gjs-type=wrapper] {
            overflow: auto;
            overflow-x: auto;
            color: black
          }
          * ::-webkit-scrollbar-track {
          }
          * ::-webkit-scrollbar-thumb {
            background-color: #0c4d82;  
            border-radius: 10px
          }
          * ::-webkit-scrollbar {
            width: 10px;
            height: 10px;
          }
          
        `,
          plugins: [
            'gjs-blocks-basic',
            pluginForms,
            grapesjsTabsPlugin,
            customCodePlugin,
            pluginTooltip,
            myNewComponentTypes,
            myNewCommands,
            myNewAssetTypes,
            myNewClasses,
            myNewProperties
          ],
          pluginOpts:{
            customCodePlugin:{
              'placeholderScript': '<div> Js code</div>'
            }
          },
          // Size of the editor
          height: '100%',
          width: 'auto',
          selectorManager: {
            appendTo: '.styles-container',
          },
          layerManager: {
            appendTo: '.layer-container',
          },
          blockManager: {
            appendTo: '.blocks-container',
          },
          traitManager: {
            appendTo: '.styles-container',
            sectors: {
              defaults: [],
            },
          },
          styleManager: {
            appendTo: '.styles-container',
            sectors: LoadStyles(),
          },
          panels: {
            defaults: LoadPanels(),
          },
          assetManager: {
            assets: [],
            noAssets: 'No images to select',
          },
          canvas: {
            styles: [
              'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
              'https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css',
              'https://www.w3schools.com/w3css/4/w3.css',
              'https://fonts.googleapis.com/css?family=Montserrat',
              'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css',
              'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.4.0/font/bootstrap-icons.css',
              'https://cdn.jsdelivr.net/npm/simple-datatables@latest/dist/style.css',
              'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.5.0/font/bootstrap-icons.css'
              // './Scripts/scripts.css'
            ],

            scripts: [
              'https://code.jquery.com/jquery-3.2.1.slim.min.js',
              'https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js',
              'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js',
              'https://cdn.jsdelivr.net/npm/bootstrap@5.1.1/dist/js/bootstrap.bundle.min.js',
              // './Scripts/scripts.js',      
            ],
          },
        })
      );
}

export default initGrapes;